{
  "createTag": "Create Tag",
  "create": "Create",
  "tagsAllowAscribeAttributesStaff": "Tags allow you to ascribe attributes to staff, and then determine which view in the app they are able to see via policies.",
  "assignTagMultipleUsers": "Assign tag to multiple users",
  "deleteATag": "Delete a Tag",
  "tagIconAndName": "Tag Icon and Name",
  "enterTagName": "Enter tag name",
  "tagHasBeenCreated": "Tag has been created",
  "sureWantDeleteTag": "Are you sure you want to delete the {{name}} tag?",
  "icon": "Icon",
  "directoryAttribute": "Directory Attribute",
  "meaning": "Meaning",
  "chooseIcon": "Choose icon"
}
